import { Suspense, lazy, useEffect, useState } from 'react';
import '../db/firebaseInit';
import './App.css';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import RootContextProvider from '../store/context/rootContext';
import ScrollToTop from '../components/util/ScrollToTop';
import Header from '../components/Header/Header';
import Loader from '../components/util/Loader';
import { auth } from '../db/auth';

const Footer = lazy(() => import('../components/Footer/Footer'));
const Home = lazy(() => import('../components/Home/Home'));
const Contact = lazy(() => import('../components/contact/Contact'));
const AboutUs = lazy(() => import('../components/contact/AboutUs'));

//medical
const Medical = lazy(() => import('../components/medical/Medical'));
const Pharmacy = lazy(() => import('../components/medical/Pharmacy'));
const CommonMed = lazy(() => import('../components/medical/CommonMed'));
const MediAssist = lazy(() => import('../components/medical/MediAssist'));
const Doctor = lazy(() => import('../components/medical/Doctor'));
const LabTest = lazy(() => import('../components/medical/LabTest'));
const DoctorDetails = lazy(() => import('../components/medical/DoctorDetails'));
const Appointment = lazy(() => import('../components/medical/Appointment'));
const Order = lazy(() => import('../components/medical/Order'));
const ThankYouMedical = lazy(() => import('../components/medical/ThankYouMedical'));
const DoctorDetailFilter = lazy(() => import('../components/medical/DoctorDetailsFilter'));

//Emergency
const Emergency = lazy(() => import('../components/emergency/Emergency'));
const Police = lazy(() => import('../components/emergency/Police'));
const Ambulance = lazy(() => import('../components/emergency/Ambulance'));
const Fire = lazy(() => import('../components/emergency/FireBrigade'));
const Hospital = lazy(() => import('../components/emergency/Hospital'));
const Wbsedcl = lazy(() => import('../components/emergency/Wbsedcl'));

//Education
const Education = lazy(() => import('../components/education/Education'));
const Teacher = lazy(() => import('../components/education/Teacher'));

//Transport
const Transport = lazy(() => import('../components/transport/Transport'));
const Toto = lazy(() => import('../components/transport/Toto'));
const Rental = lazy(() => import('../components/transport/Rental'));
const Bus = lazy(() => import('../components/transport/Bus'));
const BusTime = lazy(() => import('../components/transport/BusTime'));

//Service
const CommonService = lazy(() => import('../components/service/CommonService'));

//Grocery
const Grocery = lazy(() => import('../components/grocery/Grocery'));
const AddressFordo = lazy(() => import('../components/util/AddressFordo'));

//Bazaar
const Bazaar = lazy(() => import('../components/bazaar/Bazaar'));

//food
const Food = lazy(() => import('../components/food/Food'));

//online shop
const OnlineShop = lazy(() => import('../components/onlineShop/OnlineShop'));

const ProductScreen = lazy(() => import('../components/items/ProductScreen'));
const Cart = lazy(() => import('../components/items/Cart'));
const FindOrder = lazy(() => import('../components/findOrder/FindOrder'));

//service
const ServiceScreen = lazy(() => import('../components/service/ServiceScreen'));

//util
const ComingSoon = lazy(() => import('../components/util/ComingSoon'));
const ThankYou = lazy(() => import('../components/util/ThankYou'));

//Admin
const Admin = lazy(() => import('../components/admin/Admin'));
const AdminScreen = lazy(() => import('../components/admin/AdminScreen'));

//Auth
const Login = lazy(() => import('../components/auth/Login'));
const VendorLogin = lazy(() => import('../components/auth/VendorLogin'));
const VendorScreen = lazy(() => import('../components/admin/vendor/VendorScreen'));
const ForgetPassword = lazy(() => import('../components/auth/ForgetPassword'));

const DeliveryLogin = lazy(() => import('../components/auth/DeliveryLogin'));
const DeliveryScreen = lazy(()=> import('../components/admin/delivery/DeliveryScreen'));

//Privacy
const Privacy = lazy(() => import('../components/util/PrivacyPolicy'));

//Delivery
const Delivery = lazy(() => import('../components/delivery/Delivery'));

//Gallery
const Gallery = lazy(() => import('../components/onlineShop/Gallery'));

//Feeds
const FeedScreen = lazy(() => import('../components/feed/FeedScreen'));

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(userAuth => {
      setUser(userAuth);
    })
    return unsubscribe;
  }, [])

  return (
    <div className="App">
      <RootContextProvider>
        <BrowserRouter future={{
          v7_relativeSplatPath: true
        }}>
          <Header />
          <div style={{ marginTop: '3.6rem' }}></div>
          <Suspense fallback={<Loader />}>
            <ScrollToTop />
            <Routes>
              <Route path='/' element={<Home />} />
              <Route path='/contact' element={<Contact />} />
              <Route path='/aboutUs' element={<AboutUs />} />

              <Route path='/medical' element={<Medical />} />
              <Route path='/medical/pharmacy' element={<Pharmacy />} />
              <Route path='/medical/common/:type' element={<CommonMed />} />
              <Route path='/medical/mediAssist' element={<MediAssist />} />
              <Route path='/medical/doctor' element={<Doctor />} />
              <Route path='/medical/doctorDetails' element={<DoctorDetails />} />
              <Route path='/medical/order' element={<Order />} />
              <Route path='/medical/labTest' element={<LabTest />} />
              <Route path='/medical/thankYou' element={<ThankYouMedical />} />
              <Route path='/medical/doctor/doctorDetails/:spec' element={<DoctorDetailFilter />} />
              <Route path='/medical/appointment' element={<Appointment />} />

              <Route path='/emergency' element={<Emergency />} />
              <Route path='/emergency/police' element={<Police />} />
              <Route path='/emergency/fire' element={<Fire />} />
              <Route path='/emergency/ambulance' element={<Ambulance />} />
              <Route path='/emergency/transport' element={<Transport />} />
              <Route path='/emergency/hospital' element={<Hospital />} />
              <Route path='/emergency/wbsedcl' element={<Wbsedcl />} />

              <Route path='/education' element={<Education />} />
              <Route path='/education/teacher' element={<Teacher />} />

              <Route path='/transport' element={<Transport />} />
              <Route path='/transport/toto' element={<Toto />} />
              <Route path='/transport/car' element={<Rental />} />
              <Route path='/transport/bus' element={<Bus />} />
              <Route path='/transport/bus/:direction' element={<BusTime />} />

              <Route path='/grocery' element={<Grocery />} />
              <Route path='/grocery/fordo' element={<AddressFordo type="grocery" />} />
              <Route path='/bazaar' element={<Bazaar />} />
              <Route path='/bazaar/fordo' element={<AddressFordo type="bazaar" />} />

              <Route path='/food' element={<Food />} />
              <Route path='/onlineShop' element={<OnlineShop />} />

              <Route path='/buy/:product' element={<ProductScreen />} />
              <Route path='/cart' element={<Cart />} />
              <Route path='/findOrder' element={<FindOrder />} />
              <Route path='/findOrder/:phone' element={<FindOrder />} />

              <Route path='/delivery' element={<Delivery />} />

              <Route path='/service' element={<ServiceScreen />} />
              <Route path='/service/:type' element={<CommonService />} />

              <Route path='/feeds/:type' element={<FeedScreen />} />

              <Route path='/comingSoon' element={<ComingSoon />} />
              <Route path='/thankYou' element={<ThankYou />} />

              <Route path='/admin' element={user ? <Admin /> : <Login />} />
              <Route path='/admin/:type' element={user ? <AdminScreen /> : <Login />} />

              <Route path='/vendor/:category' element={<VendorScreen />} />
              <Route path='/delivery/screen' element={<DeliveryScreen />} />

              <Route path='/gallery/:name' element={<Gallery />} />

              <Route path='/login' element={<Login />} />
              <Route path='/vendorLogin' element={<VendorLogin />} />
              <Route path='/deliveryLogin' element={<DeliveryLogin />} />
              <Route path='/forgetPassword' element={<ForgetPassword />} />
              <Route path='/privacy' element={<Privacy />} />
              <Route path='*' element={<Navigate to="/" />} />
            </Routes>
            <Footer />
          </Suspense>
        </BrowserRouter>
      </RootContextProvider>

    </div>
  );
}

export default App;
